import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FeatureFlagService} from '@emma-labs/shared/angular';
import {FeatureFlags} from '@emma-labs/shared/typescript';
import {Observable} from 'rxjs';
import {MainComponent} from '../main/main.component';
import {NewTableSectionComponent} from './new-table-section/table-section.component';
import {OldTableSectionComponent} from './old-table-section/old-table-section.component';

@Component({
  selector: 'em-proposals-page',
  templateUrl: './proposals-page.component.html',
  imports: [NewTableSectionComponent, OldTableSectionComponent, MainComponent, AsyncPipe],
})
export class ProposalsPageComponent implements OnInit {
  isServerSidePaginationEnabled$!: Observable<boolean>;

  constructor(private readonly featureFlagService: FeatureFlagService) {}

  ngOnInit(): void {
    this.isServerSidePaginationEnabled$ = this.featureFlagService.isEnabled(
      FeatureFlags.IS_SERVER_SIDE_PAGINATION_ENABLED,
    );
  }
}
